module.exports = __webpack_public_path__ + "img/prizeExperience.bf0bc28a.png";